import { useEffect, useMemo, useState } from "react";

import { ThemeProvider as BaseThemeProvider } from "styled-components";

import defaultTheme from "./default-theme";
import winterTheme from "./seasons/winter";
import springTheme from "./seasons/spring";

import { useSelectedDate } from "../shared/hooks/use-selected-date";

import { Theme } from "../shared/types/theme-type";
import { useLocation } from "react-router-dom";
import writerTheme from "./writer-theme";
import autumnTheme from "./seasons/autumn";
import summerTheme from "./seasons/summer";
import ornamentTheme from "./ornament-theme";

export const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  const [theme, setTheme] = useState<Theme>(defaultTheme);

  const selectedDate = useSelectedDate();

  const getTheme = (month: number): Theme => {
    switch (month) {
      case 11:
      case 0:
      case 1:
        return winterTheme;
      case 2:
      case 3:
      case 4:
        return springTheme;
      case 5:
      case 6:
      case 7:
        return summerTheme;
      case 8:
      case 9:
      case 10:
        return autumnTheme;
      default:
        return defaultTheme;
    }
  };

  const { pathname } = useLocation();

  let newTheme: Theme = defaultTheme;

  switch (pathname) {
    case `/${process.env.PUBLIC_URL}`:
    case '/':
      const month = selectedDate.month();
      newTheme = getTheme(month);
      break;
    case "/date-events/":
      newTheme = writerTheme;
      break;
    case "/year-events/":
    case "/description/":
      newTheme = ornamentTheme;
      break;
    default:
      newTheme = defaultTheme;
      break;
  }
  return <BaseThemeProvider theme={newTheme}>{children}</BaseThemeProvider>;
};
